import React from "react";

const RTFRIndustries = ({ title, industries = [] }) => {
  return (
    <section className="rtfr-industries-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
        </div>

        <div className="row g-4">
          {industries.map((industry, i) => (
            <div
              key={i}
              className="col-md-6 col-lg-4"
              data-aos="fade-up"
              data-aos-delay={`${i * 100}`}
              data-aos-once="true"
            >
              <div className="rtfr-industry-card">
                <div className="rtfr-industry-icon">
                  <i className={`bi ${industry.icon}`}></i>
                </div>
                <h3 className="rtfr-industry-title">{industry.title}</h3>
                <p className="rtfr-industry-desc">{industry.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RTFRIndustries;
